import {
  RankTrackerConfig,
  RankTrackerConfigUpdate,
} from '../../Model/RankTrackerConfig';
import { AccountRepository } from '../Repositories/AccountRepository';

export class UpdateRankTrackerConfigUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(dto: RankTrackerConfigUpdate): Promise<RankTrackerConfig> {
    return this.repo.updateRankTrackerConfig(dto);
  }
}
